/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

/**
 * Workspace EventType Enum
 */
export type WorkspaceDetailEventType =
  (typeof WorkspaceDetailEventType)[keyof typeof WorkspaceDetailEventType];

export const WorkspaceDetailEventType = {
  DEFAULT: 'DEFAULT',
  TWO_WEEKS_FREE: 'TWO_WEEKS_FREE',
  ID_250124_KHAMIDAH: 'ID_250124_KHAMIDAH',
  EARLY_ACCESS_8W: 'EARLY_ACCESS_8W',
  REFERRAL_25_1Q: 'REFERRAL_25_1Q',
  AIEP_SENEDU_BASIC: 'AIEP_SENEDU_BASIC',
  AIEP_SEJONG_PRO: 'AIEP_SEJONG_PRO',
  AIEP_INCHEON_BASIC: 'AIEP_INCHEON_BASIC',
  VOUCHER_BASED: 'VOUCHER_BASED',
} as const;
